module.exports = __webpack_public_path__ + "static/media/icon-arrows.d606ea42.svg";